import { Box, Button, Switch } from "@mui/material";
import {
  DataGrid,
  gridClasses,
  GridToolbarContainer,
  GridToolbarQuickFilter,
} from "@mui/x-data-grid";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";

/* ---------- Direction C tokens (styling only) ---------- */
const FONT = "'Plus Jakarta Sans', system-ui, -apple-system, sans-serif";
const MONO = "'IBM Plex Mono', ui-monospace, monospace";
const INK = "#0F1B2A";
const INK_2 = "#3D4C60";
const MUTED = "#66748A";
const LINE = "#E4E9EF";
const PRIMARY = "#0B5C8A";

const RemovedUsers = () => {
  const [users, setUsers] = useState([]);
  const orgId = JSON.parse(localStorage.getItem("org"));
  const storedUser = JSON.parse(localStorage.getItem("user"));
  const navigate = useNavigate();

  useEffect(() => {
    const getOrg = async () => {
      const res = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/organization/get-by-admin?username=${storedUser.username}&orgId=${orgId}`,
        { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
      );
      if (
        !res.data.orgLogo &&
        !res.data.orgUsername &&
        !res.data.orgShortform
      ) {
        navigate(`/dashboard/org-details`);
      }
    };
    getOrg();
  }, []);

  useEffect(() => {
    const getOrgUsers = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/org-user/remove/all?orgId=${orgId}&username=${storedUser.username}`,
          { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
        );
        setUsers(res.data);
      } catch (error) {
        console.log(error.response.data.Exception || "Access denied");
      }
    };
    getOrgUsers();
  }, []);

  const columns = [
    {
      field: "orgUserId",
      headerName: "Org User ID",
      flex: 1,
      renderCell: (params) => (
        <span style={{ fontFamily: MONO, fontSize: 12.5, color: INK_2 }}>{params.value}</span>
      ),
    },
    {
      field: "name",
      headerName: "Name",
      flex: 1,
      renderCell: (params) => (
        <span style={{ fontWeight: 700, color: INK }}>{params.value}</span>
      ),
    },
    {
      field: "mobile",
      headerName: "Mobile No.",
      flex: 1,
      renderCell: (params) => (
        <span style={{ fontFamily: MONO, fontSize: 12.5, color: INK_2 }}>
          {params.value ? params.row.countryCode != null ? `${params.row.countryCode}${params.value}` : `+${params.value}` : "-"}
        </span>
      ),
    },
    {
      field: "email",
      headerName: "Email",
      flex: 1,
      renderCell: (params) => (
        <span style={{ color: INK_2 }}>{params.value}</span>
      ),
    },
    {
      field: "userRoleName",
      headerName: "User Role Name",
      flex: 1,
      renderCell: (params) => (
        <Box
          component="span"
          sx={{
            display: "inline-flex",
            alignItems: "center",
            px: 1.125,
            py: 0.25,
            borderRadius: "999px",
            background: "#F1F4F8",
            border: `1px solid ${LINE}`,
            color: INK_2,
            fontFamily: FONT,
            fontSize: 11.5,
            fontWeight: 700,
            lineHeight: 1.5,
            textTransform: "capitalize",
            whiteSpace: "nowrap",
          }}
        >
          {params.row.userRoleName.replace("_", " ").toLowerCase()}
        </Box>
      ),
    },
    // {
    //   field: "action",
    //   headerName: "Action",
    //   flex: 1,
    //   renderCell: (params) => (
    //     <>
    //       <Button onClick={() => navigate(`/dashboard/${params.row.orgUserId}`)}>
    //         Edit
    //       </Button>
    //       <Button onClick={() => handleRemoveUser(params.row.mobile)}>
    //         Remove
    //       </Button>
    //     </>
    //   ),
    // },
  ];

  const rows = users ? users : "";

  return (
    <div style={{ fontFamily: FONT, color: INK }}>
      <div className="dashboard-container" style={{ padding: 0, background: "transparent", boxShadow: "none" }}>
        <h1
          style={{
            margin: "8px 0 16px",
            fontFamily: FONT,
            fontSize: 27,
            fontWeight: 800,
            letterSpacing: "-0.028em",
            color: INK,
          }}
        >
          List of Users
        </h1>
        <Box
          sx={{
            background: "#fff",
            border: `1px solid ${LINE}`,
            borderRadius: "14px",
            overflow: "hidden",
          }}
        >
          <DataGrid
            rows={rows}
            columns={columns}
            initialState={{
              pagination: {
                paginationModel: {
                  pageSize: 20,
                },
              },
            }}
            pageSizeOptions={[20]}
            disableRowSelectionOnClick
            disableColumnSelector
            disableDensitySelector
            slots={{ toolbar: CustomToolbar }}
            getRowId={(row) => row.orgUserId}
            getRowClassName={(params) =>
              params.indexRelativeToCurrentPage % 2 === 0 ? "even" : "odd"
            }
            rowHeight={50}
            columnHeaderHeight={40}
            sx={{
              position: "relative",
              border: "none",
              fontFamily: `${FONT} !important`,
              color: INK,

              "& .MuiDataGrid-columnHeaderTitle": {
                fontFamily: FONT,
                fontWeight: "700 !important",
                fontSize: 10.5,
                letterSpacing: "0.09em",
                textTransform: "uppercase",
                color: MUTED,
              },
              "& .MuiDataGrid-columnHeaders": {
                background: "#F7F9FC !important",
                color: MUTED,
                fontSize: "14px",
                borderRadius: 0,
                borderTop: `1px solid ${LINE}`,
                borderBottom: `1px solid ${LINE}`,
              },
              "& .MuiDataGrid-columnHeader, & .MuiDataGrid-filler": {
                background: "#F7F9FC !important",
              },
              "& .MuiDataGrid-row:hover": {
                backgroundColor: "#F4F7FA",
              },
              "& .MuiDataGrid-cell": {
                fontSize: "13.5px",
                border: "none",
                borderBottom: "1px solid #F1F4F8",
                display: "flex",
                alignItems: "center",
              },
              "& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within, & .MuiDataGrid-columnHeader:focus": {
                outline: "none",
              },
              "& .MuiDataGrid-columnSeparator": {
                display: "none",
              },
              "& .MuiDataGrid-footerContainer": {
                borderTop: `1px solid ${LINE}`,
              },
              "& .MuiTablePagination-root, & .MuiTablePagination-displayedRows": {
                fontFamily: MONO,
                fontSize: 12,
                color: MUTED,
              },
              "& .css-1ccsd5i-MuiButtonBase-root-MuiButton-root": {
                color: "#000 !important",
                border: "1px solid #B0B0B0",
                borderRadius: "12px",
                padding: 1,
              },
              "& .MuiInputBase-root-MuiInput-root::after": {
                borderBottom: "none !important",
              },
              "& .MuiInputBase-root-MuiInput-root": {
                borderBottom: "none !important",
              },
              [`& .${gridClasses.row}.even`]: {
                backgroundColor: "#FFFFFF",
                // '&:hover': {
                //   backgroundColor: "#f6f6f6",
                // },
              },
              [`& .${gridClasses.row}.odd`]: {
                backgroundColor: "#FCFDFE",
              },
              [`& .${gridClasses.row}.even:hover, & .${gridClasses.row}.odd:hover`]: {
                backgroundColor: "#F4F7FA",
              },
              "& .MuiInput-underline:before": {
                borderBottom: "none !important",
              },
              "& .MuiInput-underline:after": {
                borderBottom: "none !important",
              },
              "& .css-5h82ro-MuiInputBase-root-MuiInput-root::after": {
                borderBottom: "none !important",
              },
            }}
          />
        </Box>
      </div>
    </div>
  );
};

export default RemovedUsers;

function CustomToolbar() {
  return (
    <GridToolbarContainer
      sx={{ display: "flex", justifyContent: "end", px: 1.75, py: 1.25, gap: 1 }}
    >
      <GridToolbarQuickFilter
        sx={{
          border: "1px solid #D5DEE7",
          borderRadius: "9px",
          padding: "3px 10px",
          background: "#FFFFFF",
          "&:hover": {
            backgroundColor: "#F4F7FA",
          },
          "&:focus-within": {
            borderColor: PRIMARY,
          },
          "& .MuiInputBase-root": {
            borderRadius: "9px",
            fontFamily: FONT,
            fontSize: 13.5,
          },
          "& .MuiInputBase-root::before, & .MuiInputBase-root::after": {
            display: "none",
          },
          "& .MuiSvgIcon-root": { color: MUTED, fontSize: 18 },
          width: 300,
        }}
      />
      {/* <GridToolbarFilterButton /> */}
    </GridToolbarContainer>
  );
}
